import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

export default function Header() {
  return (
    <header className="bg-gradient-to-r from-blue-600 to-blue-800 text-white">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <BookOpen className="h-8 w-8" />
            <h1 className="text-2xl font-bold">Formation Michel Cardinal</h1>
          </Link>
          <nav>
            <ul className="flex space-x-6">
              <li>
                <Link to="/scenarios" className="hover:text-blue-200 transition-colors">
                  Scénarios
                </Link>
              </li>
              <li>
                <Link to="/resources" className="hover:text-blue-200 transition-colors">
                  Ressources
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-blue-200 transition-colors">
                  À propos
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}